import Router from 'next/router';
import { useCallback, useContext, useEffect } from 'react';
import UserContext from '~/context/common/UserContext';
import ModalContext from '~/context/srp/ModalContext';
import ActivationMfeComponent from './ActivationMfeComponent';

export default function ActivationMfeModal() {
  const {
    isActivationModalOpen,
    setActivationModalOpen,
    setCoApplicantModalOpen
  } = useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);

  // Open modal if `partner` is in the query params
  useEffect(() => {
    const url = new URL(window.location.href);

    if (url.searchParams.get('partner')) {
      setActivationModalOpen(true);
    }
  }, [setActivationModalOpen]);

  const onClose = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('partner');
    void Router.replace(url.toString(), undefined, { shallow: true });

    setActivationModalOpen(false);
  }, [setActivationModalOpen]);

  const onActivationCompletion = useCallback(() => {
    triggerFetchUserProfile();
  }, [triggerFetchUserProfile]);

  const openCosignerFlow = useCallback(() => {
    setCoApplicantModalOpen(true);
  }, [setCoApplicantModalOpen]);

  return isActivationModalOpen ? (
    <ActivationMfeComponent
      onClose={onClose}
      onActivationCompletion={onActivationCompletion}
      openCosignerFlow={openCosignerFlow}
    />
  ) : null;
}
